import React__default from 'react';
import styled from 'styled-components';
import { COLOR_PALETTE } from '../colors/colorPalette.js';
import { isThemeContextColor, getThemeVariantColor } from '../styles/stylePropTypes.js';
import { Text } from '../text/Text.js';

const StyledBadge = styled(Text)`
  background-color: ${(props)=>isThemeContextColor(props.color) ? getThemeVariantColor(props.color) : COLOR_PALETTE[props.color]};
  background-color: ${(props)=>isThemeContextColor(props.bgColor) ? getThemeVariantColor(props.bgColor) : COLOR_PALETTE[props.bgColor]};
  border-radius: 1rem;
  padding: 0.25rem 0.45rem 0.25rem 0.5rem;
`;
const Badge = ({ color ="white" , bgColor ="context" , size ="medium" , children , ...props })=>{
    return React__default.createElement(StyledBadge, {
        "data-hpy-web-badge": true,
        ...props,
        color: color,
        bgColor: bgColor,
        size: size,
        weight: "bold"
    }, children);
};
Badge.dataId = "data-hpy-web-badge";
Badge.displayName = "Badge";

export { Badge };
